import { Link, useMatch } from "react-router-dom";
import HeaderLink from "./HeaderLink";

const CustomHeader = ({
  to,
  title,
  image,
  activeImage,
  isActive = false,
  showText = false
}) => {
  const isMatch = useMatch(to);

  return (
    <Link to={to}>
      <HeaderLink
        image={image}
        activeImage={activeImage}
        match={isMatch}
        active={isActive || isMatch}
        text={title}
        showText={showText}
      />
    </Link>
  );
};

export default CustomHeader;
